import { useEffect, useState } from "react";
import { SESSIONS, activeSessions } from "@/lib/trading";

export const SessionClock = () => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const active = activeSessions(now);
  return (
    <div className="flex items-center gap-3 font-mono text-xs" data-testid="session-clock">
      <span className="text-slate-300" data-testid="utc-time">{now.toISOString().slice(11, 19)} UTC</span>
      <div className="hidden sm:flex items-center gap-2">
        {SESSIONS.map((s) => {
          const on = active.includes(s.key);
          return (
            <span key={s.key} data-testid={`session-status-${s.key}`}
              className={`flex items-center gap-1.5 px-2 py-1 rounded border ${on ? s.badge : "border-slate-800 text-slate-600"}`}>
              <span className={`h-1.5 w-1.5 rounded-full ${on ? "animate-pulse" : ""}`} style={{ background: on ? s.color : "#334155" }} />
              {s.label}
            </span>
          );
        })}
      </div>
    </div>
  );
};
